import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { PatientjourneyService } from '../../_service/patientjourney.service';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { MiscService } from '../../_service/misc.service';
import { UserService } from '../../_service/user.service';
import { HotTableRegisterer } from '@handsontable/angular';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
import {MatDialog} from '@angular/material/dialog';
import * as XLSX from 'xlsx';
declare var $: any;
@Component({
  selector: 'app-patient-journey-listing',
  templateUrl: './patient-journey-listing.component.html',
  styleUrls: ['./patient-journey-listing.component.css']
})
export class PatientJourneyListingComponent implements OnInit {
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
  @ViewChild('admissiondateRangeStart', {static: false}) admissiondateRangeStart: ElementRef;
  @ViewChild('admissiondateRangeEnd', {static: false}) admissiondateRangeEnd: ElementRef;
  @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  IpdData:any=[];private hotRegisterer = new HotTableRegisterer();settings = {colHeaders: true };hideColumn:any;loaded:boolean=false;perpage:number=25;length:number=0;pageEvent: PageEvent;loading:boolean=true;id = 'hotInstance';userId:string;
  pageSizeOptions = [10,25,50,100];pageIndex:number=0;
  search:string;bd:string;start_date:string='';end_date:string='';admissionstart_date:string='';admissionend_date:string='';doctor:string;hospital:string;payment_mode='';status='';treatment='';circle:'';cmsid:'';
  paymentOpt=[];ActionOpt=[];myrole:string;adminRole:boolean=true;adminInsuranceRole:boolean=true;
  bds=[];bds_copy=[];doctors_copy=[];hospitals_copy=[];treatments_copy=[];doctors=[];hospitals=[];alltreatments=[];treatments=[];leadStatus=[];circles=[];columnDrp:number[]=[];submitted = false;
  reimbursement_cancelled_cheque=[];ot_room_booking=[];anaesthesia_booking=[];equipments_and_consumables_availability=[];hospital_reassurance=[];getptopspoc=[];
  patientJourneyId:any;updatedLodData=[];cancel_ipd:any=[];medical_management:any[];ot_late_reason=[];
  admit_late_reason=[];treatCategory=[];lead_category_filter='';cms=[];cms_copy=[]
  



  constructor(private leadapi:LeadsService, private sharedapi:SharedService, private userapi:UserService, private dialog:MatDialog,private patientjourneyapi:PatientjourneyService,public miscapi:MiscService) {
    this.paymentOpt = ['Cash','Cashless','Reimbursement','EMI'];
    this.ActionOpt = ['Select','Upload Insurance Card','Post OPD','Post IPD'];
    this.reimbursement_cancelled_cheque = ['Yes','No'];
    this.ot_room_booking = ['Yes','No'];
    this.anaesthesia_booking = ['Yes','No'];
    this.equipments_and_consumables_availability = ['Yes','No'];
    this.hospital_reassurance = ['Yes','No'];
    this.cancel_ipd = ['Yes','No'];
    this.medical_management = ['Yes','No'];
    this.ot_late_reason = ['Doctor came late','Equipment arrange late','Doctor busy on another OT','Proposed OT Wrong','Attendant Not available','Wrong Communication by category','Wrong OT plan by category'];
    this.admit_late_reason = ['On Time','Test Report came late','Room Not Available','OT time','Wrong communication by category','Delay in the cab','Patient came by his own','Hospital infra issue','Delay in document and report','Insurance Issue','Hospital change','Patient Not ready for admission'];

    this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
    this.userId = localStorage.getItem('loginuserId');
    this.myrole = localStorage.getItem('role');
    if(this.myrole=='1' || this.myrole=='9')
    {
        this.adminRole = false;
    }
    if(this.myrole=='1' || this.myrole=='5')
    {
        this.adminInsuranceRole = false;
    }

  }

  ngOnInit(): void {
    this.getbds();this.getcircle();
    this.getTreatment();
    this.getTreatmentCategory()
    this.getDoctor();this.getHospital();
    this.getPtOppsPOC();
    this.getCms();
    
  }

  ngAfterViewInit() {
    this.loadData(0,25);
  }

   async getbds()
    {
        this.leadapi.getbds().subscribe((data:any) => {
            if(data.status)
            {
                this.bds = data.data;
                this.bds_copy= this.bds;
            }else{
                this.bds = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getcircle()
    {
        this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getTreatment()
    {
        this.leadapi.getTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.data;
                this.treatments_copy= this.treatments;
            }else{
                this.treatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getTreatmentCategory()
    {
        await this.miscapi.getTreat_Category().subscribe((data:any) => {
            if(data.status)
            {
                this.treatCategory = data.data;
            }else{
                this.treatCategory = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getDoctor()
    {
        this.leadapi.getdoctors().subscribe((data:any) => {
            if(data.status)
            {
                this.doctors = data.data;
                this.doctors_copy= this.doctors;
            }else{
                this.doctors = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getHospital()
    {
        this.leadapi.gethospitals().subscribe((data:any) => {
            if(data.status)
            {
                this.hospitals = data.data;
                this.hospitals_copy= this.hospitals;
            }else{
                this.hospitals = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getCms()
    {
        await this.leadapi.getCms().subscribe((data:any) => {
            if(data.status)
            {
                this.cms = data.data;
                this.cms_copy=this.cms;
            }else{
                this.cms = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getPtOppsPOC() {
        this.userapi.getUserByRole(8).subscribe((data:any) => {
            data.data.forEach(element => {
                this.getptopspoc.push(
                    element.email
                );
            });
        });
        
    }

    setSearchValue(type){
        if(type=='lead_owner'){
            $("#ownerSearch").val('');
            $("#ownerSearch").focus();
          this.bds= this.bds_copy;
        }else if(type=='doctor'){
            $("#doctorSearch").val('');
            $("#doctorSearch").focus();
            this.doctors= this.doctors_copy;
        }else if(type=='hospital'){
            $("#hospitalSearch").val('');
            $("#hospitalSearch").focus();
            this.hospitals= this.hospitals_copy;
        }else if(type=='treatment'){
            $("#treatmentSearch").val('');
            $("#treatmentSearch").focus();
            this.treatments= this.treatments_copy;
        } else if(type=='cms'){
            $("#cmsSearch").val('');
            $("#cmsSearch").focus();
            this.cms= this.cms_copy;
        }
    }

    searchOnSelect(searchtText: string, type)
    {
        if(type == 'lead_owner'){
            this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
        }else if(type == 'doctor'){
            this.doctors = this.sharedapi.searchData(searchtText, this.doctors_copy, "name");
        }else if(type == 'hospital'){
            this.hospitals = this.sharedapi.searchData(searchtText, this.hospitals_copy, "name");
        }else if(type == 'treatment'){
            this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
        } else if (type == 'cms') {
            this.cms = this.sharedapi.searchData(searchtText, this.cms_copy, "name");
        }
    }

    
    async loadData(pageIndex,perpage)
    {
      this.IpdData = [];
      this.paginator.pageIndex = pageIndex;
      this.paginatorBottom.pageIndex = pageIndex;
      this.pageIndex = pageIndex;
      let qString = 'search='+this.search+'&bd='+this.bd+'&circle='+this.circle+'&hospital='+this.hospital+'&doctor='+this.doctor+'&treatment='+this.treatment+'&payment_mode='+this.payment_mode+'&date_range='+this.start_date+'-'+this.end_date+'&admission_date_range='+this.admissionstart_date+'-'+this.admissionend_date+'&status='+this.status+'&lead_category_filter='+this.lead_category_filter+'&cmsid='+this.cmsid;
      this.loading = true;this.loaded = false;
      this.patientjourneyapi.getPatientjourneyList(pageIndex,perpage,qString).subscribe((data:any) => {
        this.length = parseInt(data.totaldata);
        this.loading = false;
        this.loaded = true;
        if(data.status)
        {
            this.IpdData = data.data;

        }else{
            this.IpdData = [];
            this.sharedapi.presentToast(data.msg);
        }
      }, error => {
          this.loading = false;
          this.loaded = true;
          this.sharedapi.checkError(error);
      });
  }

  exportPatientJourneyList()
    {
        if(this.IpdData.length>0 && this.myrole=='1' || this.myrole=='8')
        {
            let data = [];
            let titles = [
            'Hospital Name',
            'Patient Name',
            'Circle',
            'Admission Time',
            'OT Date',
            'IPD ID',
            'Room Allotment',
            'Room Category',
            'Room Capping',
            'IPD Status',
            'Patient Sex',
            'Patient Number',
            'Disease',
            'Category',
            'Doc Name',
            'Mode Of Payment',
            'Implant',
            'Rental',
            'Consumable',
            'Category BD Name',
            'Cash PKG',
            'Cash PKG (Central Opps)',
            'Advance at Glamyo',
            'At Hospital',
            'Online at Glamyo',
            'Cash Collected By',
            'Category BD Contact',
            'Pt. Opps POC',
            'OT Room Booking',
            'Anaesthesia Booking',
            'Equipments and consumables availability',
            'Runner  assigned',
            'Hospital Reassurance (OT/Anaesthetist/Equip. & Consum.)',
            'Cab Boarding time',
            'Actual Cab Boarding time', 
            'Admission Time Provided by Category',
            'Patient Arrival Time', 
            'Patient Actual Admit Time',
            'If delay, reason',
            'In case of Cashless - PREAUTH',
            'OT start time',
            'Actual OT start time',
            'OT end time',
            'If late, reason',
            'Expected Discharge Date',
            'Expected Discharge Time',
            'Discharge Date',
            'Discharge Time',
            'Discharge Summary Receive Date',
            'Discharge Summary Receive Time',
            'Discharge Summary Confirm By Insurance Date',
            'Discharge Summary Confirm By Insurance Time',
            'Bill Breakup Date',
            'Bill Breakup Time',
            'Bill Sent TPA Time',
            'Final Approval Receive Date',
            'Final Approval Receive Time',
            'Final Bill Receive',
            'Doctor Visit',
            'Final Discharge Summary',
            'Final Bill',
            'In case of CASHLESS - POSTAUTH',
            'In case of REIMBURSEMENT - Cancelled & PDC cheque',
            'Co-pay/Extra Cash collection applicable',
            'Co-pay/Extra Cash collected',
            'If  Delay, Reason',
            'Discharge By',
            'Remarks',
            'Medical Management',
            'Cancel Remarks',
            'Cancel IPD',
            'CM/ACM'
            ];

            if(this.myrole=='1' || (this.myrole=='8' && this.userId == '114')){
                titles.push('Case Type');
                titles.push('Last Updated By');
                titles.push('IPD Created On');
            }
            data.push(titles);
            for(let key in this.IpdData)
            {
                let exdata = [
                    this.IpdData[key].hospital_name,
                    this.IpdData[key].patient,
                    this.IpdData[key].circle_name,
                    this.IpdData[key].arrival_time,
                    this.IpdData[key].surgery_date,
                    this.IpdData[key].patient_id,
                    this.IpdData[key].room_allotment,
                    this.IpdData[key].room_category,
                    this.IpdData[key].room_rent,
                    this.IpdData[key].status,
                    this.IpdData[key].gender,
                    this.IpdData[key].phone,
                    this.IpdData[key].treatment_name,
                    this.IpdData[key].treatment_categoriesName,
                    this.IpdData[key].doctor_name,
                    this.IpdData[key].payment_mode,
                    this.removeHtml(this.IpdData[key].consuambleData, 2),
                    this.removeHtml(this.IpdData[key].rental_requirement_text, 2),
                    this.removeHtml(this.IpdData[key].consumable_requirement_text, 2),
                    this.IpdData[key].bd_name,
                    this.IpdData[key].billed_amt,
                    this.IpdData[key].cash_pkg_pt_opps,
                    this.IpdData[key].advance_at_glamyo,
                    this.IpdData[key].at_hospital,
                    this.IpdData[key].online_at_glamyo,
                    this.IpdData[key].cash_collected_by,
                    this.IpdData[key].bd_contact,
                    this.IpdData[key].pt_opps_poc,
                    this.IpdData[key].ot_room_booking,
                    this.IpdData[key].anaesthesia_booking,
                    this.IpdData[key].equipments_and_consumables_availability,
                    this.IpdData[key].runner_assigned,
                    this.IpdData[key].hospital_reassurance,
                    this.IpdData[key].pickup_datetime,
                    this.IpdData[key].actual_cab_boarding_time,
                    this.IpdData[key].admission_time_provided_by_category,
                    this.IpdData[key].patient_arrival_time,
                    this.IpdData[key].patient_actual_admit_time,
                    this.IpdData[key].if_delay_reason,
                    this.removeHtml(this.IpdData[key].in_case_of_cashless_preauth, 2),
                    this.IpdData[key].ot_start_time,
                    this.IpdData[key].actual_ot_start_time,
                    this.IpdData[key].ot_end_time,
                    this.IpdData[key].if_late_reason,
                    this.IpdData[key].expected_discharge_date,
                    this.IpdData[key].expected_discharge_time,
                    this.IpdData[key].discharge_date,
                    this.IpdData[key].discharge_time,
                    this.IpdData[key].discharge_summary_receive_date,
                    this.IpdData[key].discharge_summary_receive_time,
                    this.IpdData[key].discharge_summary_confirm_by_insurance_date,
                    this.IpdData[key].discharge_summary_confirm_by_insurance_time,
                    this.IpdData[key].bill_breakup_date,
                    this.IpdData[key].bill_breakup_time,
                    this.IpdData[key].bill_sent_tpa_time,
                    this.IpdData[key].final_approval_receive_date,
                    this.IpdData[key].final_approval_receive_time,
                    this.IpdData[key].final_bill_receive,
                    this.IpdData[key].doctor_visit,
                    this.removeHtml(this.IpdData[key].final_discharge_summary, 2),
                    this.removeHtml(this.IpdData[key].final_bill, 2),
                    this.removeHtml(this.IpdData[key].in_case_of_cashless_postauth, 2),
                    this.IpdData[key].reimbursement_cancelled_cheque,
                    this.IpdData[key].copay_extra_cash_collection_applicable,
                    this.IpdData[key].copay_extra_cash_collected,
                    this.IpdData[key].if_discharge_delay_reason,
                    this.IpdData[key].discharge_by,
                    this.IpdData[key].remarks,
                    this.IpdData[key].medical_management,
                    this.IpdData[key].cancel_ipd_remarks,
                    this.IpdData[key].cancel_ipd,
                    this.IpdData[key].cm_name
                ];

            if(this.myrole=='1' || (this.myrole=='8' && this.userId == '114')){
                exdata.push(this.IpdData[key].case_type);
                exdata.push(this.removeHtml(this.IpdData[key].last_updated_by, 2));
                exdata.push(this.IpdData[key].ipd_created_time);
            }
                data.push(exdata)
            }

            let ws = XLSX.utils.aoa_to_sheet(data);
           /* generate workbook and add the worksheet */
           const wb: XLSX.WorkBook = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

           /* save to file */
           let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
           XLSX.writeFile(wb, 'patient_journey_'+utc+'.xlsx');
        }else{
            this.sharedapi.presentToast('Something went wrong, Try Again!');
        }
    }

  public getServerData(event:PageEvent):any
  {
      this.perpage = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.loadData(event.pageIndex,event.pageSize);
  }

  dateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.start_date = date1.value;
          this.end_date = date2.value;
          this.loadData(0,this.perpage);
      }
  }

  clearDate()
  {
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
      this.loadData(0,this.perpage);
  }

  admissiondateRangeChange(admissiondate1,admissiondate2)
  {
      if(admissiondate2.value)
      {
          this.admissionstart_date = admissiondate1.value;
          this.admissionend_date = admissiondate2.value;
          this.loadData(0,this.perpage);
      }
  }

  admissionclearDate()
  {
      this.admissiondateRangeStart.nativeElement.value = "";
      this.admissiondateRangeEnd.nativeElement.value = "";
      this.admissionstart_date = '';
      this.admissionend_date = '';
      this.loadData(0,this.perpage);
  }

  onBeforeChange = (hotInstance, changes) =>
  {
      let data= this.hotRegisterer.getInstance(this.id).getSourceData();
      let saveData = {id:data[hotInstance[0][0]].id,field_name:hotInstance[0][1],old_value:hotInstance[0][2],new_value:hotInstance[0][3]};
      if(saveData.new_value) {
        this.saveOnChange(saveData);
      }else{
        this.sharedapi.presentToast('This field will not be blank');
      }
      
  }

  async saveOnChange(saveData)
  {
      this.submitted = true;
      await this.patientjourneyapi.UpdateIpdpatientJourney(saveData).subscribe((data:any) =>
      {
          this.submitted = false;
          this.sharedapi.presentToast(data.msg);
      }, error => {
              this.sharedapi.checkError(error);
      });

  }

    openPopup(patient_journey_id:any) {
        this.patientjourneyapi.getPatientjourneyUpdateLogs(patient_journey_id).subscribe((data:any) => {
            if(data.status)
            {
                this.updatedLodData = data.data;
            }else{
                this.updatedLodData = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
                this.sharedapi.checkError(error);
        });
        console.log(this.updatedLodData);
        $('#myModal').modal();
    }
    closePopup() {
        $('#myModal').modal('hide');
    }

    afterOnCellMouseDownCallBack = (event, coords, TD) =>
    {
        if(event.target.nodeName.toLowerCase() == 'button'){
            let ptJID = event.target.attributes.id.nodeValue;
            this.openPopup(ptJID);
        }
    }

    removeHtml(content:string,type:number)
    {
        if(type==1)
        {
            return content.replace(/<[^>]*>/g, '')
        }else if(type==2)
        {
            return content.replace(/<[^>]*>/g, '\n')
        }
    }
    resetFilters()
    {
        this.search='';this.bd='';this.circle='';this.hospital='';this.doctor='';this.treatment='';this.status='';this.lead_category_filter='';this.cmsid='';this.payment_mode='';
        this.admissionclearDate();
        this.clearDate();
        this.loadData(0,25);
    }
   
}
